/** @format */

import {WidgetSettings} from 'components/PropertyWidget/model';
import {ChartIds} from 'pages/Home/DigitalCast/models/chartIds';
import {SaveSpace, Space} from 'pages/Home/DigitalCast/models/spaces';

interface Options extends SaveSpace {
  data: Space;
  widgetId: ChartIds;
  scale: boolean;
}

const updateScale = ({data, scale, widgetId, saveSpaceSettings}: Options): Space => {
  const oldSettings = data.widgetsSettings[widgetId];

  if (!oldSettings) {
    return data;
  }

  const newSettings: WidgetSettings = {...oldSettings};

  newSettings.isScaleChecked = scale;

  const result = {
    ...data,
    widgetsSettings: {
      ...data.widgetsSettings,
      [widgetId]: newSettings,
    },
  };

  saveSpaceSettings(result);

  return result;
};

export {updateScale};
